import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";
import { GenericForm } from "@/lib/Components/Form/Forms/GenericForm";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";
import { DialogSubmitButton } from "@/lib/Components/Dialog/Components/DialogSubmitButton";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { duplicateSupplierMutation } from "@/app/Suppliers/GraphQL/supplierMutations";
import { TextInput } from "@/lib/Components/Form/Inputs/TextInput";
import { toast } from "sonner";

type DuplicateSupplierDialogProps = {
  supplierId: string;
  supplierName: string;
};

export function DuplicateSupplierDialog({
  supplierId,
  supplierName,
}: DuplicateSupplierDialogProps) {
  const { close } = useDialogState();
  const { mutateAsync } = useGqlMutation(duplicateSupplierMutation);

  return (
    <BaseDialog title={`Duplicate ${supplierName}`} size="sm">
      <GenericForm
        initialValues={{
          name: "",
        }}
        onSubmit={async (values) => {
          await mutateAsync({
            id: supplierId,
            name: values.name,
          });

          toast("Supplier duplication started. This may take a moment.");

          close();
        }}
      >
        <TextInput
          label="New Supplier Name"
          name="name"
          className="col-span-full"
          inputProps={{ autoFocus: true }}
        />
        <DialogSubmitButton text="Duplicate" />
      </GenericForm>
    </BaseDialog>
  );
}
